import { render, staticRenderFns } from "./goodsOrders.vue?vue&type=template&id=61bd701d&scoped=true"
import script from "./goodsOrders.vue?vue&type=script&lang=js"
export * from "./goodsOrders.vue?vue&type=script&lang=js"
import style0 from "./goodsOrders.vue?vue&type=style&index=0&id=61bd701d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61bd701d",
  null
  
)

export default component.exports